module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 1
// module chunks = 0